import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import TextField from '@mui/material/TextField';
import { isEqual, isFunction } from 'lodash';

import ModalBoxes from '../../../../../common/feedback/ModalBoxes/ModalBoxes';
import Button from '../../../../../common/general/Button';
import ButtonGroup from '../../../../../common/general/ButtonGroup';

import './ContractSpecialistModal.scss';

export default function ContractSpecialistModal({ modalBox, leadLabel, currentLead, saveLead }) {
  const { t } = useTranslation();
  const [selectedValue, setSelectedValue] = useState(currentLead || '');

  const onSave = () => {
    isFunction(saveLead) && saveLead(selectedValue);
    modalBox.close();
  };

  const handleChange = e => {
    setSelectedValue(e.target.value);
  };

  const isSaveDisabled = isEqual(selectedValue, currentLead);

  return (
    <>
      <ModalBoxes.Body>
        <TextField
          label={leadLabel}
          value={selectedValue}
          onChange={handleChange}
          fullWidth
          variant="outlined"
          slotProps={{
            htmlInput: {
              maxLength: 225
            }
          }}
          helperText={`${selectedValue.length}/${225}`}
        />
      </ModalBoxes.Body>
      <ModalBoxes.Footer>
        <ButtonGroup>
          <Button priority="medium" onClick={modalBox.close}>
            {t('cancel')}
          </Button>
          <Button onClick={onSave} disabled={isSaveDisabled}>
            {t('save')}
          </Button>
        </ButtonGroup>
      </ModalBoxes.Footer>
    </>
  );
}

ContractSpecialistModal.className = 'contract-specialist-modal';
ContractSpecialistModal.size = 'w350';
